import React, { useEffect, useState } from 'react';
import "./FlightDetails.css"
import dateFormat from 'dateformat';
import { getFormatedDate } from '../../ReusableComponents/reusableFunctions';
import Button from '../../ReusableComponents/Button/Button';
import { AnimatedModal } from '../../ReusableComponents/AnimatedModal';
import closeIcon from "../../icons/blackClose.png"
import logAnalyzerIcon from '../../icons/logAnalyzerIcon.svg'
import reportIcon from '../../icons/reportIcon.svg'
import replayIcon from '../../icons/replayIcon.svg'
import detailsIcon from '../../icons/DetailsIcon.svg'
import { Link } from "react-router-dom";
import ButtonWithIcon from '../../ReusableComponents/ButtonWithIcon';

const FlightDetailsBanner = ({ user, flightDetails, avgAltitude, avgSpeed, onReplayFlight, plotArea, reportData, fromScreen, droneFromBackPage }) => {
    const [showReport, setShowReport] = useState(false);
    return <>
        {reportData && <AnimatedModal
            isOpen={showReport}
            height={"410px"}
            width={"45%"}
        >
            <div style={{ width: '100%', height: '100%', textAlign: 'left', padding: '10px 30px' }}>
                <div className="droneDetailsViewTitle">Report Details{flightDetails?.request_id && <span style={{ fontWeight: '500' }}>  | Req ID: {flightDetails?.request_id}</span>}</div>
                <hr style={{ margin: '10px 0px 0px 0px', width: '100%' }} />
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Customer Name">Customer Name</div>
                        <div className="droneDetailsViewValues" title={reportData?.customer_name ? reportData?.customer_name : "NA"}>{reportData?.customer_name ? reportData?.customer_name : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Crop Type">Crop Type</div>
                        <div className="droneDetailsViewValues" title={reportData?.crop_type ? reportData?.crop_type : "NA"}>{reportData?.crop_type ? reportData?.crop_type : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Agrochemical">Agrochemical</div>
                        <div className="droneDetailsViewValues" title={reportData?.pesticide ? reportData?.pesticide : "NA"}>{reportData?.pesticide ? reportData?.pesticide : "NA"}</div>
                    </div>
                </div>
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Total Amount">Total Amount</div>
                        <div className="droneDetailsViewValues" title={reportData?.amount ? `${reportData?.amount} Rs.` : "NA"}>{reportData?.amount ? `${reportData?.amount} Rs.` : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Drone Id">Drone Id</div>
                        <div className="droneDetailsViewValues" title={flightDetails?.drone_id ? flightDetails?.drone_id : "NA"}>{flightDetails?.drone_id ? flightDetails?.drone_id : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Spray Volume">Spray Volume</div>
                        <div className="droneDetailsViewValues" title={reportData?.spray_volume ? reportData?.spray_volume : "NA"}>{reportData?.spray_volume ? reportData?.spray_volume : "NA"}</div>
                    </div>
                </div>
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Completed">Completed</div>
                        <div className="droneDetailsViewValues" title={reportData?.area_percentage ? `${reportData?.area_percentage} %` : "NA"}>{reportData?.area_percentage ? `${reportData?.area_percentage} %` : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Sprayed Area">Sprayed Area</div>
                        <div className="droneDetailsViewValues" title={reportData?.spray_area ? `${reportData?.spray_area} Acr` : "NA"}>{reportData?.spray_area ? `${reportData?.spray_area} Acr` : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Plot Area">Plot Area</div>
                        <div className="droneDetailsViewValues" title={reportData?.plot_area ? `${reportData?.plot_area} Acr` : "NA"}>{reportData?.plot_area ? `${reportData?.plot_area} Acr` : "NA"}</div>
                    </div>
                </div>
                <div className="droneDetailsViewInfo" style={{ width: '100%' }}>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Spray Width">Spray Width</div>
                        <div className="droneDetailsViewValues" title={flightDetails.spray_width ? `${flightDetails.spray_width} m` : "NA"}>{flightDetails.spray_width ? `${flightDetails.spray_width} m` : "NA"}</div>
                    </div>
                    <div style={{ width: '39%' }}>
                        <div className="droneDetailsViewHeadings" title="Date">Date</div>
                        <div className="droneDetailsViewValues" title={reportData?.created_datetime ? dateFormat(reportData?.created_datetime, 'dd/mm/yyyy') : "NA"}>{reportData?.created_datetime ? dateFormat(reportData?.created_datetime, 'dd/mm/yyyy') : "NA"}</div>
                    </div>
                    <div style={{ width: '30%' }}>
                        <div className="droneDetailsViewHeadings" title="Flight Time">Flight Time</div>
                        <div className="droneDetailsViewValues" title={reportData?.flight_time ? reportData?.flight_time : "NA"}>{reportData?.flight_time ? reportData?.flight_time : "NA"}</div>
                    </div>
                </div>

                <div style={{ display: 'flex', width: '100%', alignItems: 'flex-end', justifyContent: 'flex-end', marginTop: '20px' }}>
                    <Button
                        className={'new-btn-md'}
                        isBtnActive={true}
                        text={"Ok"}
                        onClick={() => { setShowReport(false) }}
                    />
                </div>
            </div>
        </AnimatedModal>}

        <div className='flight_details_banner_container'>
            <div className='flight_details_banner_header' >
                <div className='flight_details_banner_header_right'>
                    <div className='grid_container' style={{ width: "70%" }}>
                        <div className='grid_data' style={{ color: 'white', fontSize: "20px" }}> {`${flightDetails?.project_name} / ${flightDetails?.plan_name}`}</div>
                        <div className='grid_title' style={{ color: 'white' }}>{flightDetails?.flight_id}</div>
                    </div>

                    {flightDetails?.request_id &&
                        <div className='grid_container' style={{ width: "30%" }}>
                            <div className='grid_data' style={{ color: 'white', fontSize: "20px" }}>Request ID</div>
                            <div className='grid_title' style={{ color: 'white' }}>{flightDetails?.request_id || ''}</div>
                        </div>
                    }

                </div>
                <div className='flight_details_banner_header_left'>
                    {flightDetails?.is_drone_in_maintenance && <div style={{ fontSize: "14px", backgroundColor: '#DE9000', padding: '8px 10px', borderRadius: "8px" }}>In Maintenance</div>}
                    {flightDetails?.flight_id && reportData && <div className='flightDetailsConainerIcon'>
                        <img src={reportIcon} title='Report' className='flightDetailsIcon' onClick={() => { setShowReport(true) }} />
                    </div>}
                    <div className='flightDetailsConainerIcon'>
                        <Link
                            to={{
                                pathname: '/aerogcsenterprise/flight_logAnalyzer',
                                state: {
                                    user,
                                    flightId: flightDetails?.flight_id,
                                    fromScreen: fromScreen || '',
                                    drone: droneFromBackPage || '',
                                }
                            }}
                        ><img src={logAnalyzerIcon} title='Log Analyzer' className='flightDetailsIcon' /></Link>
                    </div>
                    <div className='flightDetailsConainerIcon'>
                        <img src={replayIcon} title='Replay' className='flightDetailsIcon' onClick={onReplayFlight} />
                    </div>
                    <div className='flightDetailsConainerIcon'>
                        <Link
                            to={{
                                pathname: '/aerogcsenterprise/remote_mission/detailedlog',
                                state: {
                                    user,
                                    flightId: flightDetails?.flight_id,
                                    fromScreen: fromScreen || '',
                                    drone: droneFromBackPage || '',
                                }
                            }}
                        ><img src={detailsIcon} title='View Details' className='flightDetailsIcon' /></Link>
                    </div>
                </div>
            </div>
            <div className="droneDetailsViewContainer" style={{ marginTop: '10px' }}>
                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }} >
                    <div className="droneDetailsViewSubTitle">Flight Details</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Date">Date
                                {!flightDetails?.end_time && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.end_time ? dateFormat(flightDetails?.end_time, "dd mmm yyyy") : "NA"}>{flightDetails?.end_time ? dateFormat(flightDetails?.end_time, "dd mmm yyyy") : "NA"}</div>
                        </div>

                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Start Time">Start Time
                                {!flightDetails?.start_time && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.start_time ? dateFormat(flightDetails?.start_time, 'hh:MM:ss TT') : "NA"}>{flightDetails?.start_time ? dateFormat(flightDetails?.start_time, 'hh:MM:ss TT') : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="End Time">End Time
                                {!flightDetails?.end_time && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.end_time ? dateFormat(flightDetails?.end_time, 'hh:MM:ss TT') : "NA"}>{flightDetails?.end_time ? dateFormat(flightDetails?.end_time, 'hh:MM:ss TT') : "NA"}</div>
                        </div>
                    </div>

                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Duration">Duration
                                {!(flightDetails?.start_time && flightDetails?.end_time) && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={(flightDetails?.start_time && flightDetails?.end_time) ? getFormatedDate(flightDetails?.start_time, flightDetails?.end_time) : "NA"}>{(flightDetails?.start_time && flightDetails?.end_time) ? getFormatedDate(flightDetails?.start_time, flightDetails?.end_time) : "NA"}</div>
                        </div>

                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Pilot Name">Pilot Name
                                {!(flightDetails?.pilot_name) && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.pilot_name || "NA"}>{flightDetails?.pilot_name || "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }} />
                    </div>
                </div>

                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }}>
                    <div className="droneDetailsViewSubTitle">Spraying Details</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title={flightDetails?.software_edition === 'GREEN' || flightDetails?.software_edition === 'GREEN Ag++' || flightDetails?.software_edition === 'GREEN AG++' ? 'Sprayed Area'
                                : flightDetails?.software_edition === 'ORANGE' ? 'Survey Area'
                                    : `${flightDetails?.area_calculation_method && flightDetails?.area_calculation_method != 'null' ? `Sprayed Area (by ${flightDetails?.area_calculation_method})` : 'Area'}`}>
                                {flightDetails?.software_edition === 'GREEN' || flightDetails?.software_edition === 'GREEN Ag++' || flightDetails?.software_edition === 'GREEN AG++' ? 'Sprayed Area'
                                    : flightDetails?.software_edition === 'ORANGE' ? 'Survey Area'
                                        : `${flightDetails?.area_calculation_method && flightDetails?.area_calculation_method != 'null' ? `Sprayed Area (by ${flightDetails?.area_calculation_method})` : 'Area'}`}
                                {!flightDetails?.area_covered && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}</div>
                            <div className="droneDetailsViewValues" title={flightDetails?.area_covered ? `${(Number(flightDetails?.area_covered || 0) / 4046.85642).toFixed(2)} Acres` : "NA"}>{flightDetails?.area_covered ? `${(Number(flightDetails?.area_covered || 0) / 4046.85642).toFixed(2)} Acres` : "NA"} </div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Plot Area">Plot Area
                                {!plotArea && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={plotArea ? `${plotArea} Acres` : 'NA'}>{plotArea ? `${plotArea} Acres` : 'NA'}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Consumed Liquid (ml)">Consumed Liquid (ml)
                                {!flightDetails?.consumed_liquid && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.consumed_liquid ? flightDetails?.consumed_liquid : "NA"}>{flightDetails?.consumed_liquid ? flightDetails?.consumed_liquid : "NA"}</div>
                        </div>
                    </div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Acres by Pilot">Acres by Pilot
                                {!flightDetails?.acres && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.acres ? `${flightDetails?.acres} Acres` : "NA"}>{flightDetails?.acres ? `${flightDetails?.acres} Acres` : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Amount by Pilot">Amount by Pilot
                                {!flightDetails?.total_cost && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={`₹ ${flightDetails?.total_cost ? `${flightDetails?.total_cost} ( ${flightDetails?.acres} Acre  x  ₹${flightDetails?.cost_per_acre} )` : "0"}`}>{`₹ ${flightDetails?.total_cost ? `${flightDetails?.total_cost} ( ${flightDetails?.acres} Acre  x  ₹${flightDetails?.cost_per_acre} )` : "0"}`}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Sprayed Distance (m)">Sprayed Distance (m)
                                {!flightDetails?.distance_covered && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.distance_covered || "NA"}>{flightDetails?.distance_covered || "NA"}</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="droneDetailsViewContainer" style={{ marginTop: '15px' }}>
                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }}>
                    <div className="droneDetailsViewSubTitle">Flight Parameters</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Avg Altitude">Avg Altitude
                                {!avgAltitude && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={avgAltitude ? `${avgAltitude.toFixed(2)} m` : "NA"}>{avgAltitude ? `${avgAltitude.toFixed(2)} m` : "NA"}</div>
                        </div>

                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Avg Speed">Avg Speed
                                {!avgSpeed && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={avgSpeed ? `${avgSpeed.toFixed(2)} m/sec` : "NA"}>{avgSpeed ? `${avgSpeed.toFixed(2)} m/sec` : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }} />
                    </div>
                    <div style={{ marginTop: '15px', }}>
                        {!flightDetails?.drone_name &&
                            <div className='grid_sub_title' style={{ fontSize: '14px', color: "black", display: 'flex', justifyContent: 'left', alignItems: 'center' }}>
                                <div className='grid_sub_title' style={{ marginRight: "5px" }}> * </div>
                                <div>Note : {`${flightDetails?.drone_id} `}This drone is currently not registered</div>
                            </div>
                        }
                    </div>
                </div>

                <div className="droneDetailsViewData" style={{ width: '50%', borderRadius: '0' }}>
                    <div className="droneDetailsViewSubTitle">Drone Details</div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Drone Name">Drone Name
                                {!flightDetails?.drone_name && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.drone_name ? flightDetails?.drone_name : "NA"}>{flightDetails?.drone_name ? flightDetails?.drone_name : "NA"} </div>
                        </div>
                        <div style={{ width: '66%' }}>
                            <div className="droneDetailsViewHeadings" title="Drone ID">Drone ID
                                {!flightDetails?.drone_id && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.drone_id ? flightDetails?.drone_id : "NA"}>{flightDetails?.drone_id ? flightDetails?.drone_id : "NA"}</div>
                        </div>
                    </div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Drone UIN">Drone UIN
                                {!flightDetails.drone_uin && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails.drone_uin ? flightDetails.drone_uin : "NA"}>{flightDetails.drone_uin ? flightDetails.drone_uin : "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title="Firmware Version">Firmware Version
                                {!flightDetails?.firmware_version_number && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.firmware_version_number || "NA"}>{flightDetails?.firmware_version_number || "NA"}</div>
                        </div>
                        <div style={{ width: '33%' }}>
                            <div className="droneDetailsViewHeadings" title={flightDetails?.software_edition === 'GREEN' || flightDetails?.software_edition === 'GREEN Ag++' || flightDetails?.software_edition === 'GREEN AG++' || flightDetails?.area_calculation_method && flightDetails?.area_calculation_method != 'null' ? 'AeroGCS GREEN Build Number'
                                : flightDetails?.software_edition === 'ORANGE' ? 'AeroGCS ORANGE Build Number'
                                    : 'AeroGCS Build Number'}>{flightDetails?.software_edition === 'GREEN' || flightDetails?.software_edition === 'GREEN Ag++' || flightDetails?.software_edition === 'GREEN AG++' || flightDetails?.area_calculation_method && flightDetails?.area_calculation_method != 'null' ? 'AeroGCS GREEN Build Number'
                                        : flightDetails?.software_edition === 'ORANGE' ? 'AeroGCS ORANGE Build Number'
                                            : 'AeroGCS Build Number'}
                                {!flightDetails?.green_build_number && <span className='grid_sub_title' style={{ marginRight: "5px", fontSize: '15px' }}> * </span>}
                            </div>
                            <div className="droneDetailsViewValues" title={flightDetails?.green_build_number || "NA"}>{flightDetails?.green_build_number || "NA"}</div>
                        </div>
                    </div>
                    <div className="droneDetailsViewInfo">
                        <div style={{ width: '66%' }}>
                            <div className="droneDetailsViewHeadings" title="GPS ID">GPS ID</div>
                            <div className="droneDetailsViewValues" title={flightDetails?.gps_info ? JSON.parse(flightDetails?.gps_info)?.gpsId : "NA"}>{flightDetails?.gps_info ? JSON.parse(flightDetails?.gps_info)?.gpsId : "NA"}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>


}

export default FlightDetailsBanner